exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".src-source-forms-summary-table-summary-table-blocks-styles__questionBlock {\n  margin: 2.4rem 0rem;\n  border: 1px solid var(--cps-color-athens);\n  border-radius: 5px;\n  background-color: var(--cps-color-ash);\n}\n", ""]);

// exports
exports.locals = {
	"questionBlock": "src-source-forms-summary-table-summary-table-blocks-styles__questionBlock"
};